import { useMemo, useState } from 'react';
import { Images } from '../../assets';
import { Footer, Header } from '../../components';
import styles from './style.module.scss';
import { ImageModal } from '../../components/Modal/ImageModal';

const IMG_LIST_1 = [
  Images.rooms_1_1,
  Images.rooms_1_2,
  Images.rooms_1_3,
  Images.rooms_1_4,
  Images.rooms_1_5,
  Images.rooms_1_6,
  Images.rooms_1_7,
  Images.rooms_1_8
];
const IMG_BIG_LIST_1 = [
  Images.rooms_big_1_1,
  Images.rooms_big_1_2,
  Images.rooms_big_1_3,
  Images.rooms_big_1_4,
  Images.rooms_big_1_5,
  Images.rooms_big_1_6,
  Images.rooms_big_1_7,
  Images.rooms_big_1_8
];
const IMG_LIST_2 = [
  Images.rooms_2_1,
  Images.rooms_2_2,
  Images.rooms_2_3,
  Images.rooms_2_4,
  Images.rooms_2_5,
  Images.rooms_2_6,
  Images.rooms_2_7,
  Images.rooms_2_8
];
const IMG_BIG_LIST_2 = [
  Images.rooms_big_2_1,
  Images.rooms_big_2_2,
  Images.rooms_big_2_3,
  Images.rooms_big_2_4,
  Images.rooms_big_2_5,
  Images.rooms_big_2_6,
  Images.rooms_big_2_7,
  Images.rooms_big_2_8
];

const IMG_LIST_3 = [
  Images.rooms_3_1,
  Images.rooms_3_2,
  Images.rooms_3_3,
  Images.rooms_3_4,
  Images.rooms_3_5,
  Images.rooms_3_6,
  Images.rooms_3_7,
  Images.rooms_3_8
];
const IMG_BIG_LIST_3 = [
  Images.rooms_big_3_1,
  Images.rooms_big_3_2,
  Images.rooms_big_3_3,
  Images.rooms_big_3_4,
  Images.rooms_big_3_5,
  Images.rooms_big_3_6,
  Images.rooms_big_3_7,
  Images.rooms_big_3_8
];

export default function Page() {
  const [imgModalData, setImgModalData] = useState<{
    type: number;
    activeIndex: number;
  }>();
  const IMG_BIG_LIST = useMemo(() => {
    switch (imgModalData?.type) {
      case 1:
        return IMG_BIG_LIST_1;
      case 2:
        return IMG_BIG_LIST_2;
      case 3:
        return IMG_BIG_LIST_3;
    }
    return IMG_BIG_LIST_1;
  }, [imgModalData]);

  return (
    <>
      <div className={styles.container}>
        <Header />
        <div className={styles.content}>
          <div className={[styles.section, styles.section0].join(' ')}>
            <div className={styles.row}>
              <div className={styles.title}>ROOMS</div>
              <div className={styles.desc}>
                <div className={styles.kr}>
                  총 14개의 여성 전용 프리미엄 객실이 준비되어 있으며, 모든
                  객실에는 아래의 기본 옵션이 포함됩니다.
                  <br />- 침대, 책상, 의자, 옷장, 수납공간, 냉장고, 전자레인지,
                  세탁기, 건조기(객실 내), 에어컨, 난방, 고속 Wi-Fi
                  <br />
                  &nbsp;&nbsp;&nbsp;* 침구 세트는 제공되지 않습니다.
                </div>
                <div className={styles.en}>
                  We offer 14 premium, women-only rooms, each fully equipped
                  with the following essentials.
                  <br />- Bed, desk, chair, hanger, storage, refrigerator,
                  microwave, air conditioner, heating, laundry washer, dryer,
                  and high-speed Wi-Fi.
                  <br />
                  &nbsp;&nbsp;&nbsp;* Bedding sets are not provided separately.
                </div>
              </div>
            </div>
          </div>
          <div className={[styles.section, styles.section1].join(' ')}>
            <div className={styles.row}>
              <div className={styles.title}>LARGE</div>
              <div className={styles.desc}>
                <div className={styles.text}>
                  <span>
                    <b>라지룸</b>
                  </span>
                  <br />
                  <span>
                    레지던스 오후의 가장 여유로운 공간으로, 넉넉한 사이즈와 탁
                    트인 개방감이 돋보이는 객실입니다.
                    <br />큰 외창 설계로 자연광이 충분히 들어와 하루 종일 밝고
                    쾌적하며, 답답함이 없이 편안한 분위기를 느낄 수 있습니다.
                  </span>
                  <br />
                  <br />
                  <b>Large Room</b>
                  <br />
                  The most spacious room at Residence OHU
                  <br />
                  This space offers generous size and an open, airy atmosphere.
                  Designed with a large exterior window, the room is filled with
                  abundant natural light throughout the day, creating a bright,
                  comfortable, and refreshing environment without any sense of
                  confinement.
                  <br />
                  <br />
                  <span>
                    <b>풀옵션 구성</b>
                  </span>
                  <br />
                  <span>생활에 필요한 모든 것을 한 공간에 담았습니다.</span>
                  <br />
                  <br />
                  <b>Fully Furnished & All-Inclusive</b>
                  <br />
                  Everything you need for comfortable living is thoughtfully
                  provided in one space.
                  <br />
                  <br />
                  <span>- 침대, 책상, 의자</span> Bed, desk, and chair
                  <br />
                  <span>- 고급 천장형 시스템 에어컨</span> Premium
                  ceiling-mounted system air conditioner
                  <br />
                  <span>- 투도어 냉장고, 전자레인지</span> Two-door refrigerator
                  and microwave
                  <br />
                  <span>- 건조기능 세탁기</span> Washer with drying function
                  <br />
                  <span>- 옷 행거, 수납 공간</span> Clothes hanger and storage
                  space
                  <br />
                  <span>- 개별 화장실, 샤워실</span> Private bathroom and shower
                  <br />
                  <span>- 3중 보안 도어락</span> Triple-security door lock
                  system
                </div>
              </div>
            </div>
            <div className={styles.imgContainer}>
              {IMG_LIST_1.map((item, index) => (
                <img
                  src={item}
                  alt={`ohu-about-image-${index}`}
                  className={styles.img}
                  onClick={() =>
                    setImgModalData({ type: 1, activeIndex: index })
                  }
                />
              ))}
            </div>
          </div>
          <div className={[styles.section, styles.section2].join(' ')}>
            <div className={styles.row}>
              <div className={styles.title}>STANDARD</div>
              <div className={styles.desc}>
                <div className={styles.text}>
                  <span>
                    <b>스탠다드 룸</b>
                  </span>
                  <br />
                  <span>
                    레지던스 오후의 감성은 그대로 담고, 공간은 조금 더 아늑하게
                    설계한 실속 있는 객실입니다. <br />
                    대로변을 향한 큰 외창 덕분에 채광과 개방감은 충분하면서도,
                    머무를수록 편안함이 느껴지는 공간입니다.
                  </span>
                  <br />
                  <br />
                  <b>Standard Room</b>
                  <br />
                  It is a practical guest room that preserves the signature
                  afternoon ambiance of Residence OHU while offering a slightly
                  cozier spatial design. Thanks to its large exterior-facing
                  window overlooking the main road, the room enjoys ample
                  natural light and an open, airy feel—yet the longer you stay,
                  the more comfortably at ease you will feel in this inviting
                  space. 
                  <br />
                  <br />
                  <span>
                    <b>풀옵션 구성</b>
                  </span>
                  <br />
                  <span>생활에 필요한 모든 것을 한 공간에 담았습니다.</span>
                  <br />
                  <br />
                  <b>Fully Furnished & All-Inclusive</b>
                  <br />
                  All essential living elements are thoughtfully arranged in a
                  clean and functional space.
                  <br />
                  <br />
                  <span>- 침대, 책상, 의자</span> Bed, desk, and chair
                  <br />
                  <span>- 고급 천장형 시스템 에어컨</span> Premium
                  ceiling-mounted system air conditioner
                  <br />
                  <span>- 투도어 냉장고, 전자레인지</span> Two-door refrigerator
                  and microwave
                  <br />
                  <span>- 건조기능 세탁기</span> Washer with drying function
                  <br />
                  <span>- 옷 행거, 수납 공간</span> Clothes hanger and storage
                  space
                  <br />
                  <span>- 개별 화장실, 샤워실</span> Private bathroom and shower
                  <br />
                  <span>- 3중 보안 도어락</span> Triple-security door lock
                  system
                </div>
              </div>
            </div>
            <div className={styles.imgContainer}>
              {IMG_LIST_2.map((item, index) => (
                <img
                  src={item}
                  alt={`ohu-about-image-${index}`}
                  className={styles.img}
                  onClick={() =>
                    setImgModalData({ type: 2, activeIndex: index })
                  }
                />
              ))}
            </div>
          </div>
          <div className={[styles.section, styles.section3].join(' ')}>
            <div className={styles.row}>
              <div className={styles.title}>COMFORT</div>
              <div className={styles.desc}>
                <div className={styles.text}>
                  <span>
                    <b>컴포트 룸</b>
                  </span>
                  <br />
                  <span>
                    스탠다드룸과 동일한 객실 사이즈를 유지하면서, 건물 후면에
                    위치해 보다 조용하고 안정적인 분위기를 느낄수 있는 합리적인
                    가격의 객실입니다.<br/>대로변 소음에서 벗어나 하루를 차분하게
                    마무리하고 싶은 분들께 잘 어울리는 공간입니다.
                  </span>
                  <br />
                  <br />
                  <b>Comfort Room</b>
                  <br />
                  Maintaining the same room size as the Premium Standard Room,
                  this premium room is located at the rear side of the building,
                  offering a quieter and more peaceful atmosphere at a more
                  reasonable price. Away from main street noise, it is an ideal
                  space for those who want to relax and unwind in calm comfort
                  at the end of the day.
                  <br />
                  <br />
                  <span>
                    <b>풀옵션 구성</b>
                  </span>
                  <br />
                  <span>가격은 낮췄지만, 구성은 그대로입니다.</span>
                  <br />
                  <br />
                  <b>Fully Furnished & All-Inclusive</b>
                  <br />
                  The price is lower, but the features remain the same — fully
                  equipped for comfortable living.
                  <br />
                  <br />
                  <span>- 침대, 책상, 의자</span> Bed, desk, and chair
                  <br />
                  <span>- 고급 천장형 시스템 에어컨</span> Premium
                  ceiling-mounted system air conditioner
                  <br />
                  <span>- 투도어 냉장고, 전자레인지</span> Two-door refrigerator
                  and microwave
                  <br />
                  <span>- 건조기능 세탁기</span> Washer with drying function
                  <br />
                  <span>- 옷 행거, 수납 공간</span> Clothes hanger and storage
                  space
                  <br />
                  <span>- 개별 화장실, 샤워실</span> Private bathroom and shower
                  <br />
                  <span>- 3중 보안 도어락</span> Triple-security door lock
                  system
                </div>
              </div>
            </div>
            <div className={styles.imgContainer}>
              {IMG_LIST_3.map((item, index) => (
                <img
                  src={item}
                  alt={`ohu-about-image-${index}`}
                  className={styles.img}
                  onClick={() =>
                    setImgModalData({ type: 3, activeIndex: index })
                  }
                />
              ))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {!!imgModalData?.type && (
        <ImageModal
          index={imgModalData?.activeIndex || 0}
          photos={IMG_BIG_LIST.map((item, index) => ({ url: item, index }))}
          onClose={() => setImgModalData(undefined)}
        />
      )}
    </>
  );
}
